module.exports = __webpack_public_path__ + "img/building.c2689319.png";